"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoreCheckboxOption = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _useRefSetter = require("../../helpers/useRefSetter");

var _excluded = ["onChange", "children", "checked", "size", "cn", "disabled"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CoreCheckboxOption = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var onChange = props.onChange,
      children = props.children,
      checked = props.checked,
      size = props.size,
      cn = props.cn,
      disabled = props.disabled,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var inputEl = (0, _react.useRef)();
  var onBlockClickHandler = (0, _react.useCallback)(function () {
    inputEl.current.click();
  }, []);
  var onLabelClickHandler = (0, _react.useCallback)(function (event) {
    if (rest.id) event.preventDefault();
  }, [rest.id]);
  var setRef = (0, _useRefSetter.useRefSetter)(inputEl, ref);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
    ref: setRef,
    className: cn.input,
    type: "checkbox",
    checked: checked,
    onChange: onChange,
    disabled: disabled
  }, rest)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.size[size], (0, _defineProperty2.default)({}, cn.checked, checked), (0, _defineProperty2.default)({}, cn.disabled, disabled)),
    onClick: onBlockClickHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.checkbox
  }), !children ? null : /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: rest.id,
    className: cn.label,
    onClick: onLabelClickHandler
  }, children)));
});
exports.CoreCheckboxOption = CoreCheckboxOption;
var size = ['usual', 'small'];
CoreCheckboxOption.modes = {
  size: size
};
CoreCheckboxOption.propTypes = {
  /* component logic props */
  onChange: _propTypes.func.isRequired,
  children: _propTypes.node,
  checked: _propTypes.bool.isRequired,
  disabled: _propTypes.bool,

  /* styling modificators */
  size: (0, _propTypes.oneOf)(size),

  /*  binded classes */
  cn: _propTypes.object.isRequired
};
CoreCheckboxOption.defaultProps = {
  size: 'usual',
  disabled: false,
  children: null
};